import Script from "next/script";
import { useLocale } from "next-intl";

export const HCaptchaProvider = () => {
  const locale = useLocale();

  return (
    <Script defer src={`https://js.hcaptcha.com/1/api.js?hl=${locale}&render=explicit`} strategy='afterInteractive' />
  );
};
